import { setTrialStatus, rescheduleTrial, cancelTrialAdvanced, sendTrialOffer } from './trials';
import { createOrder } from './orders';

export const markStarted = async (id: string | number) => setTrialStatus(id, 'started');
export const markNoShow = async (id: string | number) => setTrialStatus(id, 'no_show');
export const markCompleted = async (id: string | number) => setTrialStatus(id, 'completed');

// Angebot für Trial versenden: erstellt bei Bedarf erst einen Auftrag und sendet dann das Angebot
export const sendOfferForTrial = async (trialId: string | number) => {
  return await sendTrialOffer(trialId);
};

export const createOrderForTrial = async (trialId: string | number) => createOrder(trialId, {});

export const apiRescheduleTrial = rescheduleTrial;
export const apiCancelTrial = cancelTrialAdvanced;


